import { useState, useEffect } from "react";

// Returns true when viewport width >= breakpoint (default 820px).
export function useWide(bp = 820) {
  const [wide, setWide] = useState(typeof window !== "undefined" ? window.innerWidth >= bp : false);
  useEffect(() => {
    const onResize = () => setWide(window.innerWidth >= bp);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [bp]);
  return wide;
}
